module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-palace_a1485ab.png";